<template>
  <el-dialog
    title="编辑我的资料"
    :visible.sync="editava"
    custom-class="editava"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="61.8%"
    @closed="editavaClose"
  >
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="头像：" prop="avatar">
        <div class="vCenter">
          <img :src="form.avatar" alt class="logopath" @click="upload1" />
          <div style="margin-left:20px;flex:1">
            <p>点击头像进行选择，点击上传按钮可上传本地图片。</p>
            <ul class="clearfix chooselist">
              <li class="fl">
                <um-img
                  @submit-file="submitava"
                  :submitStatus="submitImgStatus"
                  v-on:getImgSrc="editImg"
                  :uploadlogo="editupload"
                ></um-img>
              </li>
              <li v-for="item in defaultIcon" class="fl">
                <img :src="item.path" alt @click="choosecolor(item)" />
                <img src="/img/select.png" alt class="selectcolor" v-show="item.id==selectcolor" />
              </li>
            </ul>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="姓名：" prop="sumname">
        <el-input v-model="form.sumname"></el-input>
      </el-form-item>
      <el-form-item label="职位：" prop="job">
        <el-input v-model="form.job"></el-input>
      </el-form-item>
      <el-form-item label="单位：" prop="company">
        <el-input v-model="form.company"></el-input>
      </el-form-item>
      <el-form-item label="固定电话：" prop="company">
        <el-input v-model="form.stel"></el-input>
      </el-form-item>
      <el-form-item label="邮箱：" prop="email">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="个性签名：">
        <el-input type="textarea" v-model="form.signature"></el-input>
      </el-form-item>
      <!-- <el-form-item label="所在地区：">
        <div class="input-item">
          <select
            @change="getAreaList(address.level1,'city',$event);address.level2=''"
            v-model="address.level1"
            placeholder="请选择"
            id="province"
            class="province"
          >
            <option
              v-for="item in provinceList"
              :key="item.id"
              :data-code="item.code"
              :value="item.id"
            >{{item.name}}</option>
          </select>
        </div>
        <div class="input-item" v-if="address.level1!=''&&address.level1">
          <select
            v-model="address.level2"
            @change="getAreaList(address.level2,'district',$event);address.level3=''"
            placeholder="请选择"
            id="city"
            class="city"
          >
            <option
              v-for="item in cityList"
              :key="item.id"
              :data-code="item.code"
              :value="item.id"
            >{{item.name}}</option>
          </select>
        </div>
        <div
          class="input-item"
          v-if="address.level2!=''&&address.level1!=''&&address.level1&&address.level2"
        >
          <select
            v-model="address.level3"
            @change="getcode($event)"
            placeholder="请选择"
            id="district"
            class="district"
          >
            <option
              v-for="item in districtList"
              :key="item.id"
              :data-code="item.code"
              :value="item.id"
            >{{item.name}}</option>
          </select>
        </div>
      </el-form-item>
      <el-form-item label="籍贯：">
        <div class="input-item">
          <select
            @change="getAreaList1(address1.level1,'city',$event);address1.level2=''"
            v-model="address1.level1"
            placeholder="请选择"
            id="province"
            class="province1"
          >
            <option
              v-for="item in provinceList1"
              :key="item.id"
              :data-code="item.code"
              :value="item.id"
            >{{item.name}}</option>
          </select>
        </div>
        <div class="input-item" v-if="address1.level1!=''&&address1.level1">
          <select
            v-model="address1.level2"
            @change="getAreaList1(address1.level2,'district',$event);address1.level3=''"
            placeholder="请选择"
            id="city"
            class="city1"
          >
            <option
              v-for="item in cityList1"
              :key="item.id"
              :data-code="item.code"
              :value="item.id"
            >{{item.name}}</option>
          </select>
        </div>
        <div
          class="input-item"
          v-if="address1.level2!=''&&address1.level1!=''&&address1.level1&&address1.level2"
        >
          <select
            v-model="address1.level3"
            @change="getcode2($event)"
            placeholder="请选择"
            id="district"
            class="district1"
          >
            <option
              v-for="item in districtList1"
              :key="item.id"
              :data-code="item.code"
              :value="item.id"
            >{{item.name}}</option>
          </select>
        </div>
      </el-form-item>
      <el-form-item label="所在行业：">
        <div class="input-item">
          <select
            @change="getIndustryinfoList(industryinfo1.level1,'level2',$event);industryinfo1.level2=''"
            v-model="industryinfo1.level1"
            placeholder="请选择"
            id="province"
            class="level1"
          >
            <option
              v-for="item in industryinfo1List"
              :key="item.id"
              :data-code="item.code"
              :value="item.id"
            >{{item.name}}</option>
          </select>
        </div>
        <div class="input-item" v-if="industryinfo1.level1!=''&&industryinfo1.level1">
          <select
            v-model="industryinfo1.level2"
            @change="getIndustryinfoList(industryinfo1.level2,'level3',$event);industryinfo1.level3=''"
            placeholder="请选择"
            id="city"
            class="level2"
          >
            <option
              v-for="item in industryinfo2List"
              :key="item.id"
              :data-code="item.code"
              :value="item.id"
            >{{item.name}}</option>
          </select>
        </div>
        <div
          class="input-item"
          v-if="industryinfo1.level2!=''&&industryinfo1.level1!=''&&industryinfo1.level1&&industryinfo1.level2"
        >
          <select
            v-model="industryinfo1.level3"
            @change="getcode1($event)"
            placeholder="请选择"
            id="district"
            class="level3"
          >
            <option
              v-for="item in industryinfo3List"
              :key="item.id"
              :data-code="item.code"
              :value="item.id"
            >{{item.name}}</option>
          </select>
        </div>
      </el-form-item>
      <el-form-item label="学校：">
        <div class="input-item school">
          <el-select
            v-model="value"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="getSchoolList"
            :loading="loading"
          >
            <el-option v-for="item in schoolList" :key="item.code" :label="item.name" :value="item"></el-option>
          </el-select>
        </div>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="editavaClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "umEdituser",
  props: [
    "form",
    "editava",
    "usersub",
    "address",
    "address1",
    "industryinfo1",
    "defaultIcon",
    "area_code"
  ],
  data() {
    return {
      submitImgStatus: false,
      provinceList: [],
      cityList: [],
      districtList: [],
      provinceList1: [],
      cityList1: [],
      districtList1: [],
      industryinfo1List: [],
      industryinfo21List: [],
      industryinfo3List: [],
      schoolList: [],
      area_code: '',
      area_code1: '',
      industry_code: '',
      areainfo: {},
      industryinfo: {},
      value: {
      },
      loading: false
    };
  },
  watch: {
    usersub(val) {
      if (val.areainfo.result != -1 && val.areainfo != "") {
        this.getAreaList(0, "province");
        this.getAreaList(val.areainfo.level1, "city");
        this.getAreaList(val.areainfo.level2, "district");
        this.address.level1 = val.areainfo.level1;
        this.address.level2 = val.areainfo.level2;
        this.address.level3 = val.areainfo.level3;
        this.area_code = val.area_code;
        this.$forceUpdate();
      } else {
        this.getAreaList(0, "province");
      }
      if (val.homeinfo.result != -1 && val.homeinfo != "") {
        this.getAreaList1(0, "province");
        this.getAreaList1(val.homeinfo.level1, "city");
        this.getAreaList1(val.homeinfo.level2, "district");
        this.address1.level1 = val.homeinfo.level1;
        this.address1.level2 = val.homeinfo.level2;
        this.address1.level3 = val.homeinfo.level3;
        this.area_code1 = val.home_code;
        this.$forceUpdate();
      } else {
        this.getAreaList1(0, "province");
      }
      if (val.industryinfo.result != -1 && val.industryinfo != "") {
        this.getIndustryinfoList(0, "level1");
        this.getIndustryinfoList(val.industryinfo.level1, "level2");
        this.getIndustryinfoList(val.industryinfo.level2, "level3");
        this.industryinfo1.level1 = val.industryinfo.level1;
        this.industryinfo1.level2 = val.industryinfo.level2;
        this.industryinfo1.level3 = val.industryinfo.level3;
        this.industry_code = val.industry_code;
        this.$forceUpdate();
      } else {
        this.getIndustryinfoList(0, "level1");
      }
    },
    editava(val) {
      if (this.usersub.school_code != "") {
        this.$set(this.value,'code',this.usersub.school_code)
        this.$set(this.value,'name',this.usersub.school_name)
      }
      if (val&&this.value.name) {
        this.$nextTick(() => {
          $(".school .el-input__inner").val(this.value.name);
        });
      }
    }
  },
  methods: {
    editavaClose() {
      this.$emit("close");
    },
    submit() {
      this.submitImgStatus = true;
    },
    submitava(e) {
      var that = this;
      var area_name;
      if (!$(".district option:selected").text()) {
        if (!$(".city option:selected").text()) {
          area_name = $(".province option:selected").text();
        } else {
          area_name =
            $(".province option:selected").text() +
            "-" +
            $(".city option:selected").text();
        }
      } else {
        area_name =
          $(".province option:selected").text() +
          "-" +
          $(".city option:selected").text() +
          "-" +
          $(".district option:selected").text();
      }
      var area_name1;
      if (!$(".district1 option:selected").text()) {
        if (!$(".city1 option:selected").text()) {
          area_name1 = $(".province1 option:selected").text();
        } else {
          area_name1 =
            $(".province1 option:selected").text() +
            "-" +
            $(".city1 option:selected").text();
        }
      } else {
        area_name1 =
          $(".province1 option:selected").text() +
          "-" +
          $(".city1 option:selected").text() +
          "-" +
          $(".district1 option:selected").text();
      }
      var industry_name;
      if (!$(".level1 option:selected").text()) {
        if (!$(".level2 option:selected").text()) {
          industry_name = $(".level1 option:selected").text();
        } else {
          industry_name =
            $(".level1 option:selected").text() +
            "-" +
            $(".level2 option:selected").text();
        }
      } else {
        industry_name =
          $(".level1 option:selected").text() +
          "-" +
          $(".level2 option:selected").text() +
          "-" +
          $(".level3 option:selected").text();
      }
      that.submitImgStatus = false;
      if (e != "") {
        that.form.avatar = e.fullpath;
      }
      $UMCore
        .post("/route.lua", {
          data: JSON.stringify({
            functionname: "sys_user_setsub",
            modulename: "admin",
            umid: $UMCore.uncompile("umid"),
            avatar: that.form.avatar,
            sumname: that.form.sumname,
            job: that.form.job,
            company: that.form.company,
            // location:that.actaddress,
            area_code: that.area_code,
            home_code: that.area_code1,
            industry_code: that.industry_code,
            areainfo: that.address,
            homeinfo: that.address1,
            industryinfo: that.industryinfo1,
            school_code: that.value.code,
            // area_name:
            signature: that.form.signature,
            stel: that.form.stel,
            email: that.form.email,
            area_name: area_name,
            industry_name: industry_name,
            home_name: area_name1,
            school_name: that.value.name,
            areaaddress:that.usersub.areaaddress,
            homeaddress:that.usersub.homeaddress,
            cardbackground: that.form.cardbackground
          })
        })
        .then(function(res) {
          if (res.data.data.status) {
            that.$message({
              message: "修改成功！",
              type: "success",
              onClose: function() {
                that.editava = false;
                $UMCore.compile("avatar", that.form.avatar);
                $UMCore.compile("sumname", that.form.sumname);
                $UMCore.msg({
                  cmd: "user",
                  op: "editava",
                  info: "修改头像",
                  data: { avatar: that.form.avatar }
                });
              }
            });
          } else {
            that.$message.error("修改失败！");
          }
        })
        .catch(function(error) {
          that.$message.error("修改失败！");
        });
    },
    /**选择头像 */
    choosecolor(item) {
      this.selectcolor = item.id;
      this.form.avatar = item.path;
    },
    editImg(val) {
      if (this.editupload == "") {
        this.editupload = undefined;
      } else {
        this.editupload = "";
      }
      this.form.avatar = val;
      this.selectcolor = -1;
    },
    upload1() {
      $(".editava .el-upload").click();
    },
    //获取地区
    getAreaList(id, type, e) {
      $UMCore
        .post(window.zt_server + "/route.lua", {
          data: JSON.stringify({
            modulename: "area",
            functionname: "get",
            pid: id
          })
        })
        .then(res => {
          if (type == "province") {
            this.provinceList = res.data.data.slist;
            this.$forceUpdate();
          } else if (type == "city") {
            this.cityList = res.data.data.slist;
            if (e) {
              this.area_code = e.target.options[
                e.target.selectedIndex
              ].getAttribute("data-code");
            }
            this.$forceUpdate();
          } else if (type == "district") {
            this.districtList = res.data.data.slist;
            if (e) {
              this.area_code = e.target.options[
                e.target.selectedIndex
              ].getAttribute("data-code");
            }
            this.$forceUpdate();
          }
        });
    },
    /**获取籍贯 */
    getAreaList1(id, type, e) {
      $UMCore
        .post(window.zt_server + "/route.lua", {
          data: JSON.stringify({
            modulename: "area",
            functionname: "get",
            pid: id
          })
        })
        .then(res => {
          if (type == "province") {
            this.provinceList1 = res.data.data.slist;
            this.$forceUpdate();
          } else if (type == "city") {
            this.cityList1 = res.data.data.slist;
            if (e) {
              this.area_code1 = e.target.options[
                e.target.selectedIndex
              ].getAttribute("data-code");
            }
            this.$forceUpdate();
          } else if (type == "district") {
            this.districtList1 = res.data.data.slist;
            if (e) {
              this.area_code1 = e.target.options[
                e.target.selectedIndex
              ].getAttribute("data-code");
            }
            this.$forceUpdate();
          }
        });
    },
    //获取行业
    getIndustryinfoList(id, type, e) {
      $UMCore
        .post(window.zt_server + "/route.lua", {
          data: JSON.stringify({
            modulename: "industry",
            functionname: "get",
            pid: id
          })
        })
        .then(res => {
          if (type == "level1") {
            this.industryinfo1List = res.data.data.slist;
            this.$forceUpdate();
          } else if (type == "level2") {
            this.industryinfo2List = res.data.data.slist;
            if (e) {
              this.industry_code = e.target.options[
                e.target.selectedIndex
              ].getAttribute("data-code");
            }
            this.$forceUpdate();
          } else if (type == "level3") {
            this.industryinfo3List = res.data.data.slist;
            if (e) {
              this.industry_code = e.target.options[
                e.target.selectedIndex
              ].getAttribute("data-code");
            }
            this.$forceUpdate();
          }
        });
    },
    getSchoolList(m) {
      this.loading = true;
      $UMCore
        .post(window.zt_server + "/route.lua", {
          data: JSON.stringify({
            modulename: "school",
            functionname: "getlist",
            name: m,
            pagesize: -1
          })
        })
        .then(res => {
          this.loading = false;
          this.schoolList = res.data.data.slist;
        });
    },
    getcode(i) {
      this.area_code = i.target.options[i.target.selectedIndex].getAttribute(
        "data-code"
      );
    },
    getcode1(i) {
      this.industry_code = i.target.options[
        i.target.selectedIndex
      ].getAttribute("data-code");
    },
    getcode2(i) {
      this.area_code1 = i.target.options[i.target.selectedIndex].getAttribute(
        "data-code"
      );
    }
  }
};
</script> 
<style>
.editava {
  top: 50%;
  transform: translateY(-50%);
  margin-top: 0 !important;
}
.editava .avatar-uploader {
  width: 40px;
  height: 40px;
}
.editava .el-upload-dragger {
  height: 38px;
  width: 38px;
}
.editava .el-upload-dragger img {
  height: 40px;
}
.editava .avatar-uploader-icon {
  width: 36px;
  height: 36px;
  line-height: 36px !important;
}
.editava .distpicker-address-wrapper {
  width: 60%;
  float: left;
}
.editava .distpicker-address-wrapper select {
  width: 32%;
}
.editava .address {
  width: 40%;
  float: left;
}
#province,
#city,
#district {
  padding: 0.5rem 0.75rem;
  height: 40px;
  font-size: 1rem;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  float: left;
  margin-right: 10px;
}
</style>
<style lang="scss" scoped>
.chooselist {
  li {
    margin: 0 10px 10px 0;
    position: relative;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
    }
    .selectcolor {
      position: absolute;
      width: 16px;
      height: 16px;
      bottom: 0;
      right: 0;
    }
  }
  li:first-child {
    border-radius: 0;
  }
}
.logopath {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/packages/edituser/um-edituser.vue